export default __webpack_public_path__ + "static/media/simple_adoption.2ac960f1.svg";